import type { StockMovementHistoryFilters } from '../stock/public-api';
import type { HistoryFilterForm } from './inventoryOperations.types';

const CATEGORY_REASON_MAP: Record<string, string[]> = {
  ingresos: ['stock_restock', 'stock_initial_load', 'purchase_reception', 'transfer_in', 'production'],
  egresos: ['sale', 'sale_void', 'shrinkage', 'breakage', 'return', 'production_consume'],
  ajustes: ['manual_adjustment', 'physical_count', 'bulk_coefficient', 'cost_adjustment'],
  transferencias: ['transfer_out', 'transfer_in', 'transfer_rejected'],
};

export function buildHistoryFilters(form: HistoryFilterForm): StockMovementHistoryFilters {
  const filters: StockMovementHistoryFilters = {};
  const from = form.historyFromDate.trim();
  const to = form.historyToDate.trim();
  if (from) filters.fromCreatedAt = new Date(`${from}T00:00:00`).toISOString();
  if (to) filters.toCreatedAt = new Date(`${to}T23:59:59.999`).toISOString();
  if (form.historyReasonFilter !== 'all') {
    const reasons = CATEGORY_REASON_MAP[form.historyReasonFilter];
    if (reasons) {
      filters.reasons = reasons;
    } else {
      filters.reason = form.historyReasonFilter;
    }
  }
  return filters;
}
